import CalendarIcon from 'Assets/Images/icons/calendar'
import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import moment from 'moment'
import { findIndex } from 'lodash'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { LinkView } from 'Components/Link/View'
import { PageTitle } from 'Components/PageTitle'
import { Tabs } from 'Components/Tabs'
import FilteredTable from 'Containers/FilteredTable'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import { DATE_FORMAT } from 'constants.js'
import { getClientRostersByCities } from 'Reducers/Roster/actions'
import { PATHS } from 'Config/Routing/paths'
import { getWeeksFilterOptions } from '../../Utils/Table'
import StyledBreadcrumbs from '../../Components/StyledBreadcrumbs'

class ClientRosters extends React.Component {
  componentDidMount = () => {
    const { getClientRostersByCities } = this.props

    getClientRostersByCities()
  }

  render = () => (
    <HideWhenBlocked>
      <LayoutDashboard>
        <StyledBreadcrumbs
          icon={<CalendarIcon style={{ width: 14 }} />}
          breadcrumbs={[{ label: 'Rosters' }]}
        />
        <PageTitle>Rosters</PageTitle>
      </LayoutDashboard>
      {this.renderRosterTabs()}
    </HideWhenBlocked>
  )

  renderRosterTabs = () => {
    const { clientRostersByCities } = this.props
    const tabs = clientRostersByCities.map(rostersByCity =>
      this.renderRostersTab(rostersByCity),
    )

    return <Tabs id="roster-tabs" tabs={tabs} />
  }

  renderRostersTab = rostersByCity => {
    return {
      tabTitle: rostersByCity.cityName,
      tabContent: (
        <FilteredTable
          columns={[
            {
              name: 'week',
              label: '#Week',
              accessor: 'week',
              sortable: true,
            },
            {
              name: 'campaignName',
              label: 'Campaign Name',
              accessor: 'campaign.name',
              sortable: true,
            },
            {
              name: 'startDate',
              label: 'Start Date',
              accessor: 'startDate',
              sortable: true,
              render: startDate => moment(startDate).format(DATE_FORMAT),
            },
            {
              name: 'endDate',
              label: 'End Date',
              accessor: 'lastMissionDate',
              sortable: true,
              render: endDate => moment(endDate).format(DATE_FORMAT),
            },
            {
              name: 'missions',
              label: '#Missions',
              accessor: 'missionsCount',
              sortable: true,
            },
            {
              name: 'flyers',
              label: '#Flyers',
              accessor: 'flyersCount',
              sortable: true,
            },
            {
              name: 'actions',
              label: 'Actions',
              accessor: 'id',
              render: this.getViewRosterLink,
            },
          ]}
          data={rostersByCity.rosters}
          filters={[
            {
              label: 'Week',
              noValueLabel: 'All',
              options: getWeeksFilterOptions(),
              columnName: 'week',
              sorted: true,
              ASC: false,
            },
          ]}
          showSearchFilter={false}
        />
      ),
    }
  }

  getViewRosterLink = id => {
    const { clientRostersByCities } = this.props
    let roster = null

    clientRostersByCities.forEach(rostersByCity => {
      const rosterIndex = findIndex(rostersByCity.rosters, { id })

      if (rosterIndex > -1) {
        roster = rostersByCity.rosters[rosterIndex]

        return
      }
    })

    if (roster) {
      return (
        <LinkView
          to={`${PATHS.main.dashboard}/campaigns/${
            roster.campaign.id
          }/city-plans/${roster.cityPlan.id}/rosters/${roster.id}`}
        />
      )
    }

    return
  }
}

ClientRosters.propTypes = {
  getClientRostersByCities: PropTypes.func.isRequired,
  clientRostersByCities: PropTypes.array.isRequired,
}

const mapStateToProps = state => ({
  clientRostersByCities: state.rosters.clientRostersByCities,
})

export default connect(
  mapStateToProps,
  {
    getClientRostersByCities,
  },
)(ClientRosters)
